// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-input-mobile[data-v-44bb36c6]{margin-top:2rem}.filter-input-mobile__btn[data-v-44bb36c6]{display:flex;height:3rem;width:3rem;cursor:pointer;align-items:center;justify-content:center;border-radius:1rem;border-width:1px;--tw-border-opacity:1;border-color:rgb(52 122 246 / var(--tw-border-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
